import { render, staticRenderFns } from "./IndicadoresFornecedor.vue?vue&type=template&id=1585b3d8&"
import script from "./IndicadoresFornecedor.vue?vue&type=script&lang=js&"
export * from "./IndicadoresFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports